module.exports = __webpack_public_path__ + "static/img/home-active.77eb0654.png";